<template>
  <div>
    <KeepAlive>
      <SlideShowSection />
    </KeepAlive>
    <BannersSection :itemsToShow="1" position="top" />
    <ArticlesSection />
    <BannersSection :itemsToShow="2" position="middle" />
    <GalleriesSection />
    <BannersSection :itemsToShow="2" position="bottom" />
    <MediasSection />
    <AboutSection />
  </div>
</template>

<script>
import ArticlesSection from "../components/sections/ArticlesSection.vue";
import GalleriesSection from "../components/sections/GalleriesSection.vue";
import MediasSection from "../components/sections/MediasSection.vue";
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import BannersSection from "../components/sections/BannersSection.vue";

export default {
  components: {
    SlideShowSection,
    ArticlesSection,
    MediasSection,
    GalleriesSection,
    AboutSection,
    BannersSection,
  },
};
</script>
